import {
	EventDispatcher,
	Execute,
	IAssetHandle,
	IParamHandle,
	PlaySpine,
	SequenceChain,
	SpineAnimation,
	SpineResource,
	ViewFixedSize,
	asset,
	inject,
	param,
	subscription,
	view,
} from "@spawn/core";

import { Subscription } from "rxjs";
import Victor from "victor";
import { GameEvents, StartConsecutiveNudgeUpsEvent } from "../../events/events";

@view
export class NudgeUpsCounterView extends ViewFixedSize {
	@inject private readonly eventDispatcher!: EventDispatcher;

	@asset(SpineResource) public readonly nudgeCounterSpine!: IAssetHandle<SpineResource>;

	@param({ default: 1 }) animationScale!: IParamHandle<number>;
	/** Skin of the counter animation. Empty: the skin has the name of the animation. */
	@param({ default: "" }) skinName!: IParamHandle<string>;

	@subscription subscriptions: Subscription[] = [];

	private nudgeCounterAnimation!: SpineAnimation;

	/** @param anchorWidth the "anchor point" of the animation */
	constructor(anchorWidth = 263) {
		super({ size: new Victor(anchorWidth, 1) });
		this.setupAnimation();

		this.subscriptions.push(
			this.eventDispatcher
				.event$<StartConsecutiveNudgeUpsEvent>(GameEvents.StartConsecutiveNudgeUps)
				.subscribe((event) => this.playCounter(event.payload.nudgeCount))
		);
	}

	private setupAnimation(): void {
		this.nudgeCounterAnimation = new SpineAnimation(this.nudgeCounterSpine());
		this.nudgeCounterAnimation.scale = new Victor(this.animationScale(), this.animationScale());
		this.nudgeCounterAnimation.visible = false;
		this.addChild(this.nudgeCounterAnimation);
	}

	private playCounter(nudgeCounter: number): void {
		const animationName = `nudging_counter_${nudgeCounter}`;
		this.nudgeCounterAnimation.skinName = this.skinName() || animationName;
		this.nudgeCounterAnimation.visible = true;

		void new SequenceChain(
			new PlaySpine(this.nudgeCounterAnimation, animationName),
			new Execute(() => {
				this.nudgeCounterAnimation.visible = false;
			})
		).play();
	}
}
